import React, { useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'

import Messages from 'layout/header/header-tabs/messages'
import Dock from 'layout/dock/dock'
import BigChatAside from './big-chat-aside'

import { getCurrentUser } from 'state/selectors'

import {
    createOrReturnChat,
    changeTitle,
    whisperBigChatOpenStatus
} from 'state/actions'

import { getUrlParams } from 'utils/text'

const noop = () => { }

const BigChat = ({
    createOrReturnChat,
    allChats,
    changeTitle,
    userData,
}) => {
    const [currentChatId, setCurrentChatId] = useState(null)
    const [isAsideVisibleOnSmallScreens, setIsAsideVisibleOnSmallScreens] = useState(false)

    const handleUnload = useCallback(() => {
        if (userData) {
            whisperBigChatOpenStatus(userData.id, false)
        }
    }, [userData])

    useEffect(() => {
        const idIfExists = getUrlParams('id')

        changeTitle('Chat')

        if (idIfExists) {
            const chat = allChats[parseInt(idIfExists)]

            createOrReturnChat(chat)

            setCurrentChatId(parseInt(idIfExists))
        }

        // we need to do this a ton of times before it'll receive it. guessing delays in connecting or something?
        [1000,2000,3000].map(delay => {
            setTimeout(() => {
                whisperBigChatOpenStatus(userData.id, true)
            }, delay)
        })

        window.addEventListener('beforeunload', handleUnload)

        return () => {
            window.removeEventListener('beforeunload', handleUnload)
        }
    }, [])

    return (
        <div className={`big-chat ${ isAsideVisibleOnSmallScreens ? 'aside-visible' : ''}`}>
            <div 
                className='aside-bg' 
                onClick={() => setIsAsideVisibleOnSmallScreens(false)}
            />
            <div className='headertabs-container'>
                <div className='headertab'>
                    <div className='headertab-chats active'>
                        <Messages
                            isActive={true}
                            closeCallback={noop}
                            tabName={'Messages'}
                            handleScroll={noop}
                            handleTouchMove={noop}
                            setCurrentBigChat={setCurrentChatId}
                            currentBigChatId={currentChatId}
                        />
                    </div>
                </div>
            </div>
            <div className='big-chat-main'>
                <Dock
                    isBigChat
                    currentBigChatId={currentChatId}
                    setCurrentBigChat={setCurrentChatId}
                    setIsAsideVisibleOnSmallScreens={setIsAsideVisibleOnSmallScreens}
                />
            </div>
            {currentChatId ?
                <BigChatAside
                    currentChatId={currentChatId}
                    key={currentChatId}
                    noop={noop}
                />
                : null}
        </div>
    )
}

const mapStateToProps = state => ({
    allChats: state.account.entities.chats,
    userData: getCurrentUser(state),
})

export default connect(mapStateToProps, {
    createOrReturnChat,
    changeTitle
})(BigChat)


// WEBPACK FOOTER //
// ./src/components/big-chat/big-chat.jsx